import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

const context = '.page-template-template-progetto section:not(.hero)';

if (document.querySelector(context)) {

    let mm = gsap.matchMedia();

    let textProgettoArray = gsap.utils.toArray([`${context} h2`, `${context} h3`, `${context} h4`, `${context} h5`, `${context} h6`, `${context} p`, `${context} button`]);
    let proj2ImgArray = gsap.utils.toArray([`${context} .width-animation`, `${context} .width-animation-reverse`, `${context} .height-animation`, `${context} .height-animation-reverse`]);

    mm.add({
        isMobile: "(max-width: 767px)",
        isDesktop: "(min-width: 768px)"
    }, (animContext) => {
        let { isMobile, isDesktop } = animContext.conditions;
        let offset = isMobile ? 100 : 200;

        textProgettoArray.forEach(text => {
            let textProgettoTl = gsap.timeline({
                scrollTrigger: {
                    trigger: text,
                    start: `top bottom-=${offset}`,
                    end: 'bottom top',
                    once: true
                }
            });
            textProgettoTl.from(text, {opacity: 0, duration: 1, y: 20});
        });

        proj2ImgArray.forEach(img => {
            gsap.timeline({
                scrollTrigger: {
                    trigger: img,
                    start: `top bottom-=${offset}`,
                    end: 'bottom top',
                    once: true,
                    onUpdate: self => {
                        self.trigger.style.setProperty('--animWidth', "100%");
                    },
                }
            });
        });

        setTimeout(() => {
            let svgArray = gsap.utils.toArray(
                [
                    `${context}#progetto4 svg #ape-s-d g#g-ape`,
                    `${context}#progetto4 svg #ape-s-d path#contorno-ape`,
                    `${context}#progetto4 svg #ape-s-d path#triangoli`,
                    `${context}#progetto4 svg #ape-s-d g#g-pallini`,
                    `${context}#progetto4 svg #ape-s-d g#g-sanctus-dagobertus`,
                    `${context}#progetto4 svg #ape-s-d g#g-rex-protector`, 
                    `${context}#progetto4 svg #ape-s-d g#g-pallini-esterni`
                ]
            );

            
            gsap.set(`${context}#progetto4 svg #ape-s-d g#g-pallini`, {transformOrigin: "center"});

            let svgTl = gsap.timeline({
                scrollTrigger: {
                    trigger: `${context}#progetto4 svg`,
                    start: `top bottom-=${offset}`,
                    end: 'bottom top',
                    once: true,
                },
            });
            svgTl.from(svgArray, {opacity: 0, duration: 1, stagger: .2 });
            svgTl.to(svgArray[3], {duration: 60 , rotate: 360, repeat: -1, ease: "none"});
            
        }, 100);
        


    });

}